function getStoredCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) return parts.pop().split(';').shift();
}

function closeSitePopup(popup) {
  popup.classList.remove('popup--animate');

  setTimeout(() => {
    popup.style.display = 'none';

    if (popup.open) popup.close();
  }, 100);

  if (popup.dataset.mode === 'enabled' && popup.dataset.cookies) {
    document.cookie = `${popup.dataset.cookiesType}=closed; path=/; max-age=${60 * 60 * 24 * popup.dataset.cookies}`;
  }
}

function openSitePopup(popup, modal = false) {
  popup.style.display = 'block';

  if (modal && !popup.open) popup.showModal();

  setTimeout(() => {
    popup.classList.add('popup--animate');
  }, 100);
}

function initializeSitePopup(popup) {
  if (popup.dataset.sitePopupInitialized === 'true') return;

  popup.dataset.sitePopupInitialized = 'true';

  const closeButton = popup.querySelector('.cookies-trigger');
  closeButton?.addEventListener('click', () => closeSitePopup(popup));

  if (
    popup.dataset.cookies &&
    (getStoredCookie(popup.dataset.cookiesType) !== 'closed' || popup.dataset.mode === 'testing')
  ) {
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup--animate');
    }, Number(popup.dataset.displayTime) || 0);
  }
}

function initializeSitePopups(root = document) {
  root.querySelectorAll('.cookies-popup').forEach(initializeSitePopup);

  const newsletterTrigger = document.getElementById('newsletterPopupTrigger');

  if (newsletterTrigger && newsletterTrigger.dataset.sitePopupInitialized !== 'true') {
    newsletterTrigger.dataset.sitePopupInitialized = 'true';
    newsletterTrigger.addEventListener('click', () => {
      const newsletterPopup = document.querySelector('[data-cookies-type="newsletter-pop"]');

      if (newsletterPopup) openSitePopup(newsletterPopup, true);
    });
  }
}

initializeSitePopups();

if (!window.sitePopupSectionListenerAdded) {
  window.sitePopupSectionListenerAdded = true;
  document.addEventListener('shopify:section:load', (event) => initializeSitePopups(event.target));
}
